import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';

import { programsApi } from '../api/programsApi';

export const useUploadProgramsFile = () => {
  const [progress, setProgress] = useState(0);

  const { mutateAsync: uploadFile, isPending: isUploading } = useMutation({
    mutationFn: async ({
      file,
      programId,
    }: {
      file: FormData;
      programId: number;
    }) => {
      setProgress(0);
      return await programsApi.uploadProgramFile(
        file,
        programId,
        progressEvent => {
          if (progressEvent.total) {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setProgress(percentCompleted);
          }
        }
      );
    },
  });

  return {
    uploadFile,
    progress,
    isUploading,
  };
};
